














































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import moment from 'moment';
import { MatchResultModel } from '../../modules/league/models/MatchResultModel';
import { orderBy, groupBy, map } from 'lodash';

@Component({
  components: {
  },
})
export default class LatestResultsWidget extends Vue {

@Prop() private matchesResults!: MatchResultModel[];

private resultsGroupedByDate() {

    const orderedResults = orderBy(this.matchesResults, (m) => m.matchDateTime, 'asc');
    const groups = groupBy(orderedResults, (match) => this.$moment(match.matchDateTime).format('dddd, DD.MM'));

    return map(groups, (group, date) => ({ date, results: group}) );
  }

}
